// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

import i18next from 'i18next';
import uiStore from '../../utils/UIStore';
import mapSliderValue from './MapSliderValue';

let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

// create a helpful text from the current slider value
export function pageAnnouncement(slider_value) {
  const mapped_value = mapSliderValue(slider_value); // 0..10
  if (mapped_value <= 0.5) return uiTexts.lengthSlider.half_page;
  if (mapped_value <= 1.5) return uiTexts.lengthSlider.one_page;

  // from here on: 0.5 steps for the number of pages
  const snapped = Math.round(mapped_value * 2) / 2; // z.B. 2.49 -> 2.5
  return `${formatHalfStep(snapped)} ${uiTexts.lengthSlider.pages_with_value}`;
}

function formatHalfStep(value) {
  const currentLocale = i18next.language;
  const isInteger = Number.isInteger(value);

  return value.toLocaleString(currentLocale, {
    minimumFractionDigits: isInteger ? 0 : 1,
    maximumFractionDigits: isInteger ? 0 : 1,
  });
}
